export default {
  // 获取保利威视token
  getPolyvToken: () => `/xkh/teacherapi/supervision/system/getPolyvToken`,
  getQuesstionInfo: () => `/xkh/teacherapi/supervision/system/getQuesstionInfo`,
  insinfo: () => `/xkh/teacherapi/supervision/system/course/insinfo`,
  viewVideo: () => `/xkh/teacherapi/correction/view/video`,
  // 获取 diy 题目信息
  getNewQuesstionInfo: () => `/xkh/teacherapi/supervision/system/getNewQuesstionInfo`,
  // 获取高频互动的签名
  getGaopinSign: () => `/xkh/teacherapi/base/getSign`,
  getAliToken: () => `/xkh/teacherapi/supervision/system/getAliToken`
}
